import { render } from "./inventory.vue?vue&type=template&id=5ee95c42&scoped=true&ts=true"
import script from "./inventory.vue?vue&type=script&lang=ts"
export * from "./inventory.vue?vue&type=script&lang=ts"

import "./inventory.vue?vue&type=style&index=0&id=5ee95c42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee95c42"]])

export default __exports__